import { Sprite, Texture } from 'pixi.js';
import vars from '../vars';

class MainStage {
  constructor(parent) {
    this.parent = parent;

    this.sprite = new Sprite();
    this.container = new Sprite(Texture.WHITE);
    this.container.alpha = 0;

    this.resize();

    this.sprite.sortableChildren = true;
    this.sprite.addChild(this.container);
    this.parent.addChild(this.sprite);
  }

  resize() {
    this.container.width = vars.layout.FRAME_WIDTH;
    this.container.height = vars.layout.MAIN_STAGE_HEIGHT;

    this.sprite.position.y = vars.layout.FRAME_TOP_DIFFERENCE;
  }

  destroy() {
    this.sprite.destroy({ children: true });
  }
}

export default MainStage;
